import styles from "./Vitrine.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { IProduto } from "shared/interfaces/IProduto";
import { ProdutoCard } from "../modal/ProdutoCard";
import { listarProdutos } from "shared/services/api/produto.api";

type Filtro =  | "todos" | "novidades" | "infantil" | "masculino" | "feminino";
const LIMITE = 50;

export const Vitrine: React.FC  = () => {
  const [filtro, setFiltro] = useState<Filtro>("todos");
  const [produtosFiltrados, setProdutosFiltrados] = useState<IProduto[]>([]);
  const [loading, setLoading] = useState(false);
  const [carregandoMais, setCarregandoMais] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [temMaisProdutos, setTemMaisProdutos] = useState(true);
  const sentinelaRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {buscarProdutos("todos", 1, true);}, []);

  const buscarProdutos = async (novoFiltro: Filtro,novaPagina: number,substituir = false) => {
    try {
      if (substituir) setLoading(true);
      else setCarregandoMais(true);

      const resultado = await listarProdutos({
        page: novaPagina,
        limit: LIMITE,
        variety: true,
        sort: "NEWEST",
      });

      const novosProdutos = Array.isArray(resultado) ? resultado : resultado.produtos ?? [];

      if (novosProdutos.length === 0) {
        setTemMaisProdutos(false);
        return;
      }

      if (substituir) {
        setProdutosFiltrados(novosProdutos);
      } else {
        setProdutosFiltrados((produtosAtuais) => {
          const idsExistentes = new Set(
            produtosAtuais.map((produto) => produto.id)
          );
          const produtosNovos = novosProdutos.filter(
            (produto: IProduto) => !idsExistentes.has(produto.id)
          );

          return [...produtosAtuais, ...produtosNovos];
        });
      }

      setPagina(novaPagina);
      setTemMaisProdutos(novosProdutos.length >= LIMITE);
        } catch (error) {
        if (substituir) setProdutosFiltrados([]);} 
        finally {setLoading(false); setCarregandoMais(false);}
    };

  const handleFiltro = async (novoFiltro: Filtro) => {
    if (loading || carregandoMais) return;

    setFiltro(novoFiltro);
    setPagina(1);
    setTemMaisProdutos(true);
    setProdutosFiltrados([]);

    await buscarProdutos(novoFiltro, 1, true);
  };

  useEffect(() => {
    const elemento = sentinelaRef.current;

    if (!elemento) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entrada = entries[0];
        if (!entrada.isIntersecting || loading || carregandoMais || !temMaisProdutos) {return;}

        buscarProdutos(filtro, pagina + 1, false);
      },
      {
        root: null,
        rootMargin: "500px 0px",
        threshold: 0,
      }
    );

    observer.observe(elemento);

    return () => observer.disconnect();
  }, [filtro, pagina, loading, carregandoMais, temMaisProdutos]);

  return (
    <section className={styles.page}>
      <div className={styles.linkContainer}>
        <button type="button"
          className={`${styles.linkindicado} ${filtro === "todos" ? styles.ativo : ""}`} onClick={() => handleFiltro("todos")}>
          Todos
        </button>

        <button type="button"
          className={`${styles.linkindicado} ${
            filtro === "novidades" ? styles.ativo : ""}`} onClick={() => handleFiltro("novidades")}>
          Novidades
        </button>

        <button type="button"
          className={`${styles.linkindicado} ${
            filtro === "infantil" ? styles.ativo : ""}`} onClick={() => handleFiltro("infantil")}>
          Infantil
        </button>

        <button type="button"
          className={`${styles.linkindicado} ${
            filtro === "masculino" ? styles.ativo : ""}`} onClick={() => handleFiltro("masculino")}>
          Masculino
        </button>

        <button type="button"
          className={`${styles.linkindicado} ${
            filtro === "feminino" ? styles.ativo : ""}`} onClick={() => handleFiltro("feminino")}>
          Feminino
        </button>
      </div>

      {loading ? (
        <div className={styles.carregando}>Carregando produtos...</div>
      ) : produtosFiltrados.length === 0 ? (
        <div className={styles.semProdutos}>
          Nenhum produto encontrado para este filtro.
        </div>
      ) : (
        <>
          <div className={styles.produtosGrid}>
            {produtosFiltrados.map((produto) => (
              <div key={produto.id} className={styles.produtoItem}>
                <ProdutoCard produto={produto} variant="indicados" />
              </div>
            ))}
          </div>

          {temMaisProdutos && (
            <div ref={sentinelaRef} className={styles.sentinela}>
              {carregandoMais && (<span>Carregando mais produtos...</span>)}
            </div>
          )}

          {!temMaisProdutos && produtosFiltrados.length > 0 && (
            <div className={styles.fimLista}>
              Você chegou ao fim da vitrine.
            </div>
          )}
        </>
      )}
    </section>
  );
};